function ExpertsPanel({
	firstLetter,
	people
}) {
	const peopleList = people.map(
		({
			label,
			isRefined,
			highlighted,
			count,
			value
		}) => {
			const name = highlighted.label || label;
			const checked = isRefined ? "checked" : "";
			const countLabel = count > 1 ? "results" : "result";
			const countText = `${count} ${countLabel}`;
			return `
				<label class="inline-checkbox" data-term="${name}">
					<input class="form-checkbox" type="checkbox" ${checked} value="${value}">
					<span class="">${name}</span>
					<span class="count">${countText}</span>
				</label>
			`;
		}
	).join("");
	
	return `
	<div class="item-wrapper item-parent flex flex-wrap justify-between gap-2">
		<label class="" data-term="${firstLetter}">
			<span class="h5">${firstLetter}</span>
				<button class="btn text-btn sub-filters-toggle" type="button" uk-toggle="target: #${firstLetter.toLowerCase()}Filters; animation: reveal-top" aria-expanded="true">
					<span class="sr-only">Expand Section ${firstLetter}</span>
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g id="angle / small / down / thick">
							<path id="Path" d="M5 9.27504L12 17L19 9.27504L17.4274 8L12 13.9901L6.5726 8L5 9.27504Z" fill="black"></path>
						</g>
					</svg>
				</button>
			</label>
			<div id="aFilters" class="sub-filters">
				<div class="sub-filters-wrapper">
					${peopleList}
				</div>
			</div>
		</div>
	`;
}

export default ExpertsPanel;